const httpMethod = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
function throwNonSuccessStatus(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

function callApi(url, method = httpMethod.GET, data = undefined, authorizationToken = undefined) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (authorizationToken) {
    headers.Authorization = authorizationToken;
  }

  return fetch(url, {
    method,
    body: JSON.stringify(data),
    headers,
  }).then(throwNonSuccessStatus)
    .then(response => response.json());
}

function callApiToHandleFiles(url, method = httpMethod.GET, data = undefined) {
  return fetch(url, {
    method,
    body: data,
  }).then(throwNonSuccessStatus)
    .then(response => response.json());
}

function getQueryStringFromObject(params) {
  // Input: {Test: [1,2], name:'bob'}
  // Output: Test=1&Test=2&name=bob
  return Object
    .keys(params)
    .map((k) => {
      if (Array.isArray(params[k])) {
        return params[k]
          .map(val => `${encodeURIComponent(k)}=${encodeURIComponent(val)}`)
          .join('&');
      }
      return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`;
    })
    .join('&');
}

// Api service
class Api {
  signIn = body => callApi('/api/ascendUser', httpMethod.POST, body);

  signInModified = token => callApi('/api/ascendUser', httpMethod.POST, undefined, token);

  signInDetails = () => callApi('/api/ascendUser/details');

  signOut = () => callApi('/api/ascendUser/signOut');

  fakeSignIn = () => callApi('/api/ascendUser/fakeSignIn', httpMethod.POST);

  // AQEFeatures

  getAQEFeatures = aqeCarrierId => callApi(`/api/aqefeatures/${aqeCarrierId}`);

  updateAQEFeatures = (aqeCarrierId, body) => callApi(`/api/aqefeatures/${aqeCarrierId}`, httpMethod.POST, body);

  // Contents
  getContents = contentId => callApi(`/api/contents/${contentId}`);

  getContentsByCarrier = queryString => callApi(`/api/contents${queryString}`);

  renderLiquidContents = (body, carrierId = null) => {
    let carrierQueryInfo = '';
    if (carrierId) {
      carrierQueryInfo = `&carrierId=${carrierId}`;
    }
    return callApi(`/api/contents/renderLiquid?${carrierQueryInfo}`, httpMethod.POST, body);
  }

  addContent = body => callApi('/api/contents', httpMethod.POST, body);

  updateContent = (contentId, body) => callApi(`/api/contents/${contentId}`, httpMethod.PATCH, body);

  deleteContent = contentId => callApi(`/api/contents/${contentId}`, httpMethod.DELETE);

  // Client
  currentClient = () => callApi('/api/clients/current');

  getClient = clientId => callApi(`/api/clients/${clientId}`);

  getClients = () => callApi('/api/clients?limit=1000');

  // Carrier
  carrier = (carrierId) => {
    let url;
    if (carrierId) {
      url = `/api/carriers/${carrierId}`;
    } else {
      url = '/api/carriers?limit=1';
    }
    return callApi(url);
  };

  getCarriers = (limit = 10) => callApi(`/api/carriers?limit=${limit}`);

  updateCarrier = (carrierId, body) => callApi(`/api/carriers/${carrierId}`, httpMethod.PATCH, body);

  addCarrier = body => callApi('/api/carriers', httpMethod.POST, body);

  // Features
  features = carrierId => callApi(`/api/features/${carrierId}`);

  updateFeatures = (carrierId, body) => callApi(`/api/features/${carrierId}`, httpMethod.POST, body);

  // Forms
  getForms = queryString => callApi(`/api/forms${queryString}`);

  getFormById = formId => callApi(`/api/forms/${formId}`);

  addForm = body => callApi('/api/forms', httpMethod.POST, body);

  // Plans
  getPlans = queryString => callApi(`/api/plans?${getQueryStringFromObject(queryString)}`);

  getPlansCount = (carrierId, searchTerm = '', planYear = []) => callApi(`/api/plans/count/${carrierId}?searchTerm=${searchTerm}&${getQueryStringFromObject({ planYear })}`);

  getPlanByIdAndLanguage = (planId, queryString) => callApi(`/api/plans/${planId}${queryString}`);

  addPlan = body => callApi('/api/plans', httpMethod.POST, body);

  updatePlan = (planId, body) => callApi(`/api/plans/${planId}`, httpMethod.PATCH, body);

  deletePlan = planId => callApi(`/api/plans/${planId}`, httpMethod.DELETE);

  // Plan Benefits
  addPlanBenefit = body => callApi('/api/planBenefits', httpMethod.POST, body);

  updatePlanBenefit = (benefitId, body) => callApi(`/api/planBenefits/${benefitId}`, httpMethod.PATCH, body);

  updateBatchPlanBenefits = body => callApi('/api/planBenefits/Batch', httpMethod.PATCH, body);

  deletePlanBenefit = benefitId => callApi(`/api/planBenefits/${benefitId}`, httpMethod.DELETE);

  // Plan Benefit Categories
  getPlanBenefitCategories = () => callApi('/api/planBenefitCategories');

  getPlanBenefitCategoryById = benefitId => callApi(`/api/planBenefitCategories/${benefitId}`);

  addPlanBenefitCategory = body => callApi('/api/planBenefitCategories', httpMethod.POST, body);

  updatePlanBenefitCategory = (benefitId, body) => callApi(`/api/planBenefitCategories/${benefitId}`, httpMethod.PATCH, body);

  updateBatchPlanBenefitCategories = body => callApi('/api/planBenefitCategories/Batch', httpMethod.PATCH, body);

  deletePlanBenefitCategory = benefitId => callApi(`/api/planBenefitCategories/${benefitId}`, httpMethod.DELETE);

  // Region
  getRegionsByCarrierId = queryString => callApi(`/api/regions${queryString}`);

  addRegion = body => callApi('/api/regions', httpMethod.POST, body);

  // Theme
  theme = carrierId => callApi(`/api/themes?carrierId=${carrierId}`);

  updateTheme = body => callApi('/api/themes', httpMethod.POST, body);

  uploadFile = file => callApiToHandleFiles('/api/FileUploads', httpMethod.PUT, file);

  fetchFileNames = (clientName, carrierId) => callApiToHandleFiles(`/api/FileUploads/${clientName}/${carrierId}`);

  computeFilePath = (clientName, carrierId, fileName, extension) => callApiToHandleFiles(`/api/FileUploads/filePath/${clientName}/${carrierId}/${fileName}/${extension}`);
}

export default new Api();
